// =======================
// SUPPORT COMPONENT
// =======================

import React, { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

function Support({ user }) {
  const [text, setText] = useState("");
  const [image, setImage] = useState("");
  const [preview, setPreview] = useState("");

  // Handle Image Upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setImage(reader.result);
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  // Handle Complaint Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🛑 IMPORTANT: Block if user is not logged in
    if (!user) {
      toast.error("Please login first!");
      return;
    }

    if (!text) return toast.error("Please enter your complaint!");

    const payload = {
      user: user?._id,   // ⭐ Safe access
      message: text,
      image: image
    };

    try {
      await axios.post("http://localhost:5000/api/support", payload);

      toast.success("Complaint submitted successfully!");

      setText("");
      setImage("");
      setPreview("");

    } catch (error) {
      toast.error("Error sending complaint");
      console.log(error);
    }
  };

  return (
    <div className="container py-4">
      <Toaster />

      <h2 className="text-center mb-4">Submit Fruit Complaint</h2>

      <form
        onSubmit={handleSubmit}
        className="card p-3 mx-auto shadow"
        style={{ maxWidth: "500px" }}
      >
        <textarea
          placeholder="Describe your issue with fruits..."
          className="form-control mb-3"
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={4}
        />

        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className="form-control mb-3"
        />

        {preview && (
          <img
            src={preview}
            alt="Preview"
            className="mb-3"
            style={{
              width: "100%",
              maxHeight: "250px",
              objectFit: "cover",
              borderRadius: "10px"
            }}
          />
        )}

        <button type="submit" className="btn btn-primary w-100">
          Submit Complaint
        </button>
      </form>
    </div>
  );
}

export default Support;
